<template>
  <div class="spider-title flex flex-col justify-center"><slot></slot></div>
</template>

<script>
export default {
  name: "SpiderTitle"
};
</script>

<style scoped>
.spider-title {
  height: 4.424rem;
  flex: 0 0 4.424rem;
}
@media screen and (min-width: 768px) {
  .spider-title {
    height: 5.056rem;
    flex: 0 0 5.056rem;
  }
}
</style>
